import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  action?: { label: string; to: string };
}

export default function SectionHeading({ eyebrow, title, desc, action }: SectionHeadingProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 md:mb-10 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <p className="flex items-center gap-2 text-xs font-semibold tracking-[0.24em] text-primary-600">
          <span className="h-1 w-6 rounded-full bg-primary-500" aria-hidden="true"></span>
          {eyebrow}
        </p>
        <h2 className="mt-3 font-heading text-2xl font-black leading-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
      </div>
      {action && (
        <Link
          to={action.to}
          className="inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-md border border-foreground-300 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          {action.label}
          <i className="ri-arrow-right-line text-base leading-none" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}